import Label1 from "../../assets/label1.png";
import Label2 from "../../assets/label2.png";
import Label3 from "../../assets/label3.png";
import Label4 from "../../assets/label4.png";
import Label5 from "../../assets/label5.png";
import Label6 from "../../assets/label6.png";

export default function LabelingImgV1() {
  return (
    <div className="policy-labeling-container">
      <div className="policy-labeling-box">
        <img src={Label1} alt="policy1" />
        <div>
          <h3>일반 개인정보 수집</h3>
          <ul>
            <li>이름</li>
            <li>전화번호</li>
            <li>이메일 주소</li>
          </ul>
          <p>*세부 항목은 『개인정보처리방침』 본문 확인</p>
        </div>
      </div>
      <div className="policy-labeling-box">
        <img src={Label2} alt="policy2" />
        <div>
          <h3>민감정보 수집</h3>
          <ul>
            <li>신용정보</li>
            <li>이동통신사</li>
            <li>주민등록번호</li>
          </ul>
          <p>*세부 항목은 『개인정보처리방침』 본문 확인</p>
        </div>
      </div>
      <div className="policy-labeling-box">
        <img src={Label3} alt="policy3" />
        <div>
          <h3>개인정보 보유기간 및 파기</h3>
          <ul className="small-ul">
            <li>이용계약</li>
            <li>종료 후 파기</li>
          </ul>
          <div className="two-line-p-tag">
            <p className="small-P-Tag">
              *일부 개인정보는 관련 법령에 따라 1년 이상 보관,
            </p>
            <p className="small-P-Tag" style={{ top: "238px" }}>
              세부 항목은 『개인정보처리방침』 본문 확인
            </p>
          </div>
        </div>
      </div>
      <div className="policy-labeling-box">
        <img src={Label4} alt="policy4" />
        <div>
          <h3>개인정보 처리 목적</h3>
          <ul>
            <li>본인확인</li>
            <li>금융서비스 제공</li>
          </ul>
          <p>*세부 항목은 『개인정보처리방침』 본문 확인</p>
        </div>
      </div>
      <div className="policy-labeling-box">
        <img className="resizing-img" src={Label5} alt="policy5" />
        <div>
          <h3>개인정보의 제공</h3>
          <ul>
            <li>[제 3자 제공] </li>
            <li>제휴관계(서비스 제공을 위한 금융사)</li>
          </ul>
          <p>*세부 항목은 『개인정보처리방침』 본문 확인</p>
        </div>
      </div>
      <div className="policy-labeling-box">
        <img src={Label6} alt="policy6" />
        <div>
          <h3>개인정보 보호책임자</h3>
          <ul className="last-box">
            <li>이름 : 박지훈 </li>
            <li>직책 : 부장</li>
            <li>전화 : 1544-9664 </li>
            <li>메일 : privacy@edencorp.kr</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
